import React, { useState } from 'react';
import { Row, Col, Select, Radio, Input, Button } from 'antd';
import { QuestionCircleOutlined, DollarCircleFilled } from '@ant-design/icons';

import SpanComponent from '@sharedComponent/span-component';
import Header from '@sharedComponent/header/header';
import AddDomain from './add-domain/add-domain-page';
import { constructTrackingStrings } from '@helpers';
import TrackingStrings from '@sharedComponent/tracking-strings';
import HelpTooltip from '@sharedComponent/help-tooltip/help-tooltip';

const { Option } = Select;

const ValueInput = ({ label, name, defaultValue, handleChange }) => (
	<Col xl={12} md={12} sm={24} xs={24} className="value_box">
		<Row className="value_input" align="middle" justify="center">
			<Col className="value" xl={5} md={8} sm={24} xs={24}>
				<SpanComponent>{label}</SpanComponent>
			</Col>
			<Col className="input_class" xl={19} md={16} sm={24} xs={24}>
				<Input defaultValue={defaultValue} name={name} onChange={(e) => handleChange(e)} />
			</Col>
		</Row>
	</Col>
);

const EditCampaignPresentational = ({
	type,
	history,
	handleChange,
	saveCampaign,
	domains,
	addDomain,
	removeDomain,
	editDomain,
	campaign: {
		campaignId,
		campaignName,
		cpcCommission,
		sourceId,
		sourceTitle,
		sourceValue1,
		sourceValue2,
		sourceValue3,
		sourceValue4,
		sourceValue5,
		step1Commission,
		step2Commission,
	},
	editCampaignLoading,
	domainListLoading,
	affId,
	clientSourceId,
}) => {
	const [value, setvalue] = useState(1);
	const onChange = (e) => {
		setvalue(e.target.value);
	};
	const header = type === 'add' ? 'Add' : 'Edit';
	const titleText = type === 'add' ? 'ADD NEW' : 'EDIT';
	let trackingStrings = null;
	trackingStrings = constructTrackingStrings({ sourceValue1, sourceValue2, sourceValue3, sourceValue4, sourceValue5 });
	return (
		<Row className="campaign_add_edit_container">
			<Col xl={24}>
				<Header title={`${header} Campaign`} />
			</Col>
			<Col xl={24}>
				<Col xl={24} className="campaign_container_box">
					<Col xl={24} className="campaign_container_title">
						<SpanComponent className="campaign_container_title_text">{titleText} CAMPAIGN</SpanComponent>
					</Col>
					<Col xl={24} className="campaign_container_body">
						<Row justify="space-between">
							<Col xl={16}>
								<Row>
									<Col xl={24} md={12} sm={12} xs={12} className="campaign_label_value">
										<SpanComponent className="campaign_container_label">Campaign</SpanComponent>
										<SpanComponent className="campaign_container_colon">:</SpanComponent>
										<Select disabled style={{ width: 240 }} placeholder="Select a Campaign" value={campaignName}></Select>
										{/* <Input value={campaignName} disabled /> */}
									</Col>
								</Row>
								<Row className="value_container" align="middle">
									<ValueInput label="Value 1" name="sourceValue1" defaultValue={sourceValue1} handleChange={handleChange} />
									<ValueInput label="Value 2" name="sourceValue2" defaultValue={sourceValue2} handleChange={handleChange} />
									<ValueInput label="Value 3" name="sourceValue3" defaultValue={sourceValue3} handleChange={handleChange} />
									<ValueInput label="Value 4" name="sourceValue4" defaultValue={sourceValue4} handleChange={handleChange} />
									<ValueInput label="Value 5" name="sourceValue5" defaultValue={sourceValue5} handleChange={handleChange} />
								</Row>
								<Row className="affiliate_commission">
									<Col xl={24}>
										<SpanComponent className="affiliate_commission_title">Affiliate Commission</SpanComponent>
									</Col>
									<Col xl={20} lg={20} md={24} sm={24} xs={24} className="affiliate_commission_container">
										<Row justify="space-between">
											<Col xl={8} md={12} sm={24} xs={24} className="affiliate_commission_box">
												<Col>
													<Row align="middle" justify="start">
														<Radio.Group
															className="affiliate_commission_radio"
															onChange={onChange}
															value={value}
															style={{ margin: 0, display: 'flex' }}>
															<Radio value={1}>CPC</Radio>
															{/* <Radio value={2}>CPA</Radio> */}
														</Radio.Group>
														<HelpTooltip style={{ paddingLeft: 0 }} title="CPC" />
													</Row>
													<Col className="commission_input">
														<Input
															defaultValue={cpcCommission}
															name="cpcCommission"
															prefix={<DollarCircleFilled className="site-form-item-icon" />}
															onChange={handleChange}
														/>
													</Col>
												</Col>
											</Col>
											<Col xl={8} md={12} sm={24} xs={24} className="affiliate_commission_box">
												<Col>
													<Col>
														<SpanComponent className="commission_text">Step 1</SpanComponent>
														<HelpTooltip title="Step 1" />
													</Col>
													<Col className="commission_input">
														<Input
															defaultValue={step1Commission}
															name="step1Commission"
															prefix={<DollarCircleFilled className="site-form-item-icon" />}
															onChange={handleChange}
														/>
													</Col>
												</Col>
											</Col>
											<Col xl={8} md={12} sm={24} xs={24} className="affiliate_commission_box">
												<Col>
													<Col>
														<SpanComponent className="commission_text">Step 2</SpanComponent>
														<HelpTooltip title="Step 2" />
													</Col>
													<Col className="commission_input">
														<Input
															defaultValue={step2Commission}
															name="step2Commission"
															prefix={<DollarCircleFilled className="site-form-item-icon" />}
															onChange={handleChange}
														/>
													</Col>
												</Col>
											</Col>
										</Row>
									</Col>
									<Col xl={24} lg={24} md={24} sm={24} xs={24}>
										<TrackingStrings value={`affId=${clientSourceId}${trackingStrings}`} />
										{!domainListLoading &&
											domains.map((data, i) => (
												<TrackingStrings key={i} value={`${data.domainName}/?affId=${clientSourceId}${trackingStrings}`} />
											))}
									</Col>
								</Row>
							</Col>
							<Col xl={6} lg={6} md={24} sm={24} xs={24}>
								<AddDomain
									domains={domains}
									removeDomain={removeDomain}
									addDomain={addDomain}
									editDomain={editDomain}
									domainListLoading={domainListLoading}
								/>
							</Col>
						</Row>
					</Col>
					<Col style={{ textAlign: 'right' }} className="btn_area_bottom">
						<Button className="cancel_btn" onClick={() => history.goBack()}>
							Cancel
						</Button>
						<Button loading={editCampaignLoading} className="save_btn" onClick={saveCampaign}>
							Save Changes
						</Button>
					</Col>
				</Col>
			</Col>
		</Row>
	);
};

export default EditCampaignPresentational;
